window.OEJ_STORE_LOCATOR_DATA = [
  {
    "id": 1,
    "name": "9M Sex Toy",
    "address": "522 W 19th St, Costa Mesa, CA 92627",
    "lat": 33.6435405,
    "lng": -117.9214452,
    "geocode_name": "522, West 19th Street, Costa Mesa, Orange County, California, 92627, United States"
  },
  {
    "id": 2,
    "name": "Adam & Eve Bangor",
    "address": "657 Broadway, Bangor, ME 04401",
    "phone": "(207) 401-4736",
    "lat": 44.823378,
    "lng": -68.778837,
    "geocode_name": "657, Broadway, Bangor, Penobscot County, Maine, 04401, United States"
  },
  {
    "id": 3,
    "name": "Adam & Eve Bend",
    "address": "1531 NE 3rd St, Bend, OR 97701",
    "phone": "(986)213-3179",
    "lat": 44.0655715,
    "lng": -121.3029704,
    "geocode_name": "Adam & Eve Stores, 1531, Northeast 3rd Street, Bend, Deschutes County, Oregon, 97701, United States"
  },
  {
    "id": 4,
    "name": "Adam & Eve Boise",
    "address": "6919 W Fairview Ave, Boise, ID 83704",
    "phone": "208-376-0068",
    "lat": 43.6188782,
    "lng": -116.2680321,
    "geocode_name": "6919, West Fairview Avenue, Boise, Ada County, Idaho, 83704, United States"
  },
  {
    "id": 5,
    "name": "Adam & Eve Casper",
    "address": "4709 W Yellowstone Hwy, Mills, WY 82604",
    "phone": "(307)922-0176",
    "lat": 42.8514678,
    "lng": -106.3841558,
    "geocode_name": "4709, West Yellowstone Highway, Mills, Natrona County, Wyoming, 82604, United States"
  },
  {
    "id": 6,
    "name": "Adam & Eve Cheyenne",
    "address": "2115 E Lincolnway, Cheyenne, WY 82001",
    "phone": "307-227-2252",
    "lat": 41.1383546,
    "lng": -104.79238,
    "geocode_name": "2115, East Lincolnway, Cheyenne, Laramie County, Wyoming, 82001, United States"
  },
  {
    "id": 7,
    "name": "Adam & Eve Coeur d'Alene",
    "address": "348 W Bosanko Ave # D, Coeur d'Alene, ID 83815",
    "phone": "208-664-1400",
    "lat": 47.7115839,
    "lng": -116.7908619,
    "geocode_name": "348, West Bosanko Avenue, Coeur d'Alene, Kootenai County, Idaho, 83815, United States"
  },
  {
    "id": 8,
    "name": "Adam & Eve Denver South",
    "address": "4697 E Evans Ave Suite 103, Denver, CO 80222",
    "phone": "720-734-3778",
    "lat": 39.6788046,
    "lng": -104.932485,
    "geocode_name": "4697, East Evans Avenue, Denver, Colorado, 80222, United States"
  },
  {
    "id": 9,
    "name": "Adam & Eve Downtown Denver",
    "address": "1331 E Colfax Ave, Denver CO 80218",
    "phone": "303-529-2547",
    "lat": 39.7403801,
    "lng": -104.9700598,
    "geocode_name": "1331, East Colfax Avenue, Swallow Hill Historic District, Denver, Colorado, 80218, United States"
  },
  {
    "id": 10,
    "name": "Adam & Eve Duluth",
    "address": "2116 Maple Grove Rd, Duluth, MN 55811",
    "phone": "218-522-4556",
    "lat": 46.8072793,
    "lng": -92.1647131,
    "geocode_name": "Adam & Eve, 2116, Maple Grove Road, Duluth Heights, Central Duluth, Duluth, Saint Louis County, Minnesota, 55811, United States"
  },
  {
    "id": 11,
    "name": "Adam & Eve Greenfield",
    "address": "18 Main St Greenfield NH 01301",
    "lat": 42.6013,
    "lng": -72.6236,
    "geocode_name": "ZIP centroid 01301 Greenfield MA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 12,
    "name": "Adam & Eve Idaho Falls",
    "address": "118 1st Street, Idaho Falls, ID 83401",
    "phone": "208-242-3948",
    "lat": 43.4970457,
    "lng": -112.0325615,
    "geocode_name": "118, 1st Street, Downtown, Idaho Falls, Bonneville County, Idaho, 83401, United States"
  },
  {
    "id": 13,
    "name": "Adam & Eve Joplin",
    "address": "108 N Rangeline Rd, Joplin, MO 64801",
    "phone": "986-218-9431",
    "lat": 37.0937492,
    "lng": -94.4769739,
    "geocode_name": "108, North Range Line Road, East Joplin, Joplin, Jasper County, Missouri, 64801, United States"
  },
  {
    "id": 14,
    "name": "Adam & Eve Kalispell",
    "address": "280 2nd Ave E N, Kalispell, MT 59901",
    "phone": "(406)755-8369",
    "lat": 48.202158,
    "lng": -114.315321,
    "geocode_name": "Kalispell, Flathead County, Montana, United States"
  },
  {
    "id": 15,
    "name": "Adam & Eve Killeen",
    "address": "3800 E Stan Schlueter Loop, Killeen, TX 76542",
    "phone": "(254) 312-8188",
    "lat": 31.0702662,
    "lng": -97.7110914,
    "geocode_name": "3800, East Stan Schlueter Loop, Killeen, Bell County, Texas, 76542, United States"
  },
  {
    "id": 16,
    "name": "Adam & Eve Lincoln",
    "address": "4327 E O St, Lincoln, NE 68510",
    "phone": "402-256-6654",
    "lat": 40.8138574,
    "lng": -96.6104219,
    "geocode_name": "East 'O' Street Office Park, Meadowlane, Bethany, Lincoln, Lancaster County, Nebraska, United States"
  },
  {
    "id": 17,
    "name": "Adam & Eve Madison",
    "address": "6807 Odana Rd, Madison, WI 53719",
    "phone": "608-820-1655",
    "lat": 43.0562598,
    "lng": -89.4993003,
    "geocode_name": "Adam & Eve, 6807, Odana Road, Odana Park, Madison, Dane County, Wisconsin, 53717, United States"
  },
  {
    "id": 18,
    "name": "Adam & Eve Meridian",
    "address": "1327 East Fairview Ave MERIDIAN, ID 83642",
    "phone": "208-609-9250‬",
    "lat": 43.6190451,
    "lng": -116.3779938,
    "geocode_name": "1327, East Fairview Avenue, Meridian, Ada County, Idaho, 83642, United States"
  },
  {
    "id": 19,
    "name": "Adam & Eve Nampa",
    "address": "4213 Garrity Blvd, Nampa, ID 83687",
    "phone": "208-461-4676",
    "lat": 43.594337,
    "lng": -116.5184273,
    "geocode_name": "4213, Garrity Boulevard, Nampa, Canyon County, Idaho, 83687, United States"
  },
  {
    "id": 20,
    "name": "Adam & Eve Ogden",
    "address": "3531 Harrison Blvd, Ogden, UT 84403",
    "phone": "986.278.1386",
    "lat": 41.1988536,
    "lng": -111.948832,
    "geocode_name": "3531, Harrison Boulevard, Ogden, Weber County, Utah, 84403, United States"
  },
  {
    "id": 21,
    "name": "Adam & Eve Old Port",
    "address": "424 Fore St, Portland, ME 04101",
    "phone": "(207) 871-0356",
    "lat": 43.6559187,
    "lng": -70.2540738,
    "geocode_name": "424, Fore Street, Old Port, Portland, Cumberland County, Maine, 04101, United States"
  },
  {
    "id": 22,
    "name": "Adam & Eve Omaha",
    "address": "3507 S 84th St, Omaha, NE 68124",
    "phone": "986-218-9427",
    "lat": 41.226201,
    "lng": -96.043028,
    "geocode_name": "3507, South 84th Street, Omaha, Douglas County, Nebraska, 68124, United States"
  },
  {
    "id": 23,
    "name": "Adam & Eve Pocatello",
    "address": "657 N Main St, Pocatello, ID 83204",
    "phone": "208-235-9457",
    "lat": 42.8662504,
    "lng": -112.4555393,
    "geocode_name": "657, North Main Street, Pocatello, Bannock County, Idaho, 83204, United States"
  },
  {
    "id": 24,
    "name": "Adam & Eve Portland",
    "address": "9220 SW Barbur Blvd Suite #115, Portland, OR 97219",
    "phone": "503-244-1604",
    "lat": 45.4587374,
    "lng": -122.7088101,
    "geocode_name": "Adam & Eve, 9220, Southwest Barbur Boulevard, Multnomah, Portland, Multnomah County, Oregon, 97219, United States"
  },
  {
    "id": 25,
    "name": "Adam & Eve Pullman",
    "address": "205 NW Whitman St Pullman, WA 99163",
    "phone": "509-584-4419‬",
    "lat": 46.732605,
    "lng": -117.1803526,
    "geocode_name": "205, Northwest Whitman Street, Military Hill, Ward 1, Pullman, Whitman County, Washington, 99163, United States"
  },
  {
    "id": 26,
    "name": "Adam & Eve Sarasota",
    "address": "4400 S Tamiami Trail, Sarasota, FL 34231",
    "phone": "941-263-0345",
    "lat": 27.290291,
    "lng": -82.530753,
    "geocode_name": "4400, South Tamiami Trail, South Trail, Sarasota, Sarasota County, Florida, 34231, United States"
  },
  {
    "id": 27,
    "name": "Adam & Eve Spokane",
    "address": "3609 N Division St Suite A, Spokane, WA 99207",
    "phone": "509-290-6435",
    "lat": 47.6913588,
    "lng": -117.4116144,
    "geocode_name": "Spokane Cigar and Tobacco, 3609, North Division Street, Nevada Heights, Spokane, Spokane County, Washington, 99218, United States"
  },
  {
    "id": 28,
    "name": "Adam & Eve Sugarhouse",
    "address": "2153 S 700 E, Salt Lake City, UT 84106",
    "phone": "385-261-2972",
    "lat": 40.724091,
    "lng": -111.870993,
    "geocode_name": "2153, 700 East, Sugar House, Salt Lake City, Salt Lake County, Utah, 84106, United States"
  },
  {
    "id": 29,
    "name": "Adam & Eve Twin Falls",
    "address": "1111 Blue Lakes Blvd N Unit F, Twin Falls, ID 83301",
    "phone": "208-595-2398",
    "lat": 42.5820456,
    "lng": -114.4603775,
    "geocode_name": "1111, Blue Lakes Boulevard North, Twin Falls, Twin Falls County, Idaho, 83301, United States"
  },
  {
    "id": 30,
    "name": "Adam & Eve West Valley",
    "address": "3443 W 3500 S, West Valley City, UT 84119",
    "phone": "801-999-4719",
    "lat": 40.6965909,
    "lng": -111.9808255,
    "geocode_name": "3500 South, Western Acres, West Valley City, Salt Lake County, Utah, 84120, United States"
  },
  {
    "id": 31,
    "name": "Adult Empire",
    "address": "9Ave B Leetsdale, PA 15056",
    "lat": 40.5662,
    "lng": -80.2099,
    "geocode_name": "ZIP centroid 15056 Leetsdale PA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 32,
    "name": "Adult Megaplexx",
    "address": "11827 San Pedro SanAntonio, TX 78216",
    "lat": 29.5491063,
    "lng": -98.4898918,
    "geocode_name": "Adult Megaplex, 11827, San Pedro Avenue, San Antonio, Bexar County, Texas, 78216, United States"
  },
  {
    "id": 33,
    "name": "Adult Video Warehouse",
    "address": "4500 N Powerline Rd Pompano Beach, FL 33703",
    "lat": 26.2855325,
    "lng": -80.1522084,
    "geocode_name": "4500, North Powerline Road, Deerfield Beach, Broward County, Florida, 33073, United States"
  },
  {
    "id": 34,
    "name": "Adult Video Warehouse",
    "address": "8760 Gateway Blvd East El Paso, TX 79907",
    "lat": 31.7276332,
    "lng": -106.3127915,
    "geocode_name": "8760, Gateway Boulevard East, Loma Terrace, El Paso, El Paso County, Texas, 79907, United States"
  },
  {
    "id": 35,
    "name": "Ai Eros Adult Novelty Store",
    "address": "9Ave B Leetsdale, PA 15056",
    "lat": 40.5662,
    "lng": -80.2099,
    "geocode_name": "ZIP centroid 15056 Leetsdale PA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 36,
    "name": "All for love",
    "address": "3072 S Main St Salt Lake City, UT 84115",
    "lat": 40.7295768,
    "lng": -111.891102,
    "geocode_name": "Main Street, Ballpark, Salt Lake City, Salt Lake County, Utah, 84114, United States"
  },
  {
    "id": 37,
    "name": "AM Entertainment",
    "address": "154-18 Rockaway Rd Ste 2FL Jamaica, NY 11434",
    "lat": 40.6775,
    "lng": -73.7758,
    "geocode_name": "ZIP centroid 11434 Jamaica NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 38,
    "name": "Amoura",
    "address": "151 W 4th St, Pomona, CA 91766",
    "lat": 34.0560993,
    "lng": -117.750636,
    "geocode_name": "151, West 4th Street, Edison Historic District, Pomona, Los Angeles County, California, 91766, United States"
  },
  {
    "id": 39,
    "name": "Bada Bing",
    "address": "12205 Tamiami TRL, Punta Gorda, FL 33955",
    "phone": "941-575-7333",
    "lat": 26.9123834,
    "lng": -82.0440485,
    "geocode_name": "Tamiami Trail, Punta Gorda, Charlotte County, Florida, 33950, United States"
  },
  {
    "id": 40,
    "name": "BEST KEPT SECRET",
    "address": "216-15 NORTHERN BLVD. BAYSIDE, NY 11361",
    "lat": 40.7627,
    "lng": -73.7745,
    "geocode_name": "ZIP centroid 11361 Bayside NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 41,
    "name": "Bra Bella",
    "address": "2318 Merrick Rd Merrick, NY 11566",
    "lat": 40.6606726,
    "lng": -73.5398786,
    "geocode_name": "2318, Merrick Road, Merrick, Town of Hempstead, Nassau County, New York, 11566, United States"
  },
  {
    "id": 42,
    "name": "Bridget & Chams Hot Flixx LSMT",
    "address": "Bridget & Chams Hot Flixx 3369 Sarno Rd Melbourne, FL 32934",
    "lat": 28.1331,
    "lng": -80.7112,
    "geocode_name": "ZIP centroid 32934 Melbourne FL",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 43,
    "name": "Caliente Hialeah",
    "address": "1820 W 8th Ave, Hialeah, FL 33010",
    "phone": "305-885-1100",
    "lat": 25.8382705,
    "lng": -80.2980925,
    "geocode_name": "1820, West 8th Avenue, Hialeah, Miami-Dade County, Florida, 33010, United States"
  },
  {
    "id": 44,
    "name": "Caliente Miami",
    "address": "11980 SW 8th Street, Miami, FL 33184",
    "phone": "305-392-1855",
    "lat": 25.7604696,
    "lng": -80.3898845,
    "geocode_name": "11980, Southwest 8th Street, Tamiami, Miami, Miami-Dade County, Florida, 33184, United States"
  },
  {
    "id": 45,
    "name": "Christies Sales",
    "address": "21 South Cooley Drive Oklahoma City,, OK 73127",
    "lat": 35.466513,
    "lng": -97.6817301,
    "geocode_name": "21, South Cooley Drive, Oklahoma City, Canadian County, Oklahoma, 73127, United States"
  },
  {
    "id": 46,
    "name": "Cupid Boutique",
    "address": "786 Grand Blvd. Deer Park, NY 11729",
    "lat": 40.7605859,
    "lng": -73.3110575,
    "geocode_name": "786, Grand Boulevard, Deer Park, Town of Babylon, Suffolk County, New York, 11729, United States"
  },
  {
    "id": 47,
    "name": "CW Whitewater",
    "address": "1157 Sweetwater Rd. Spring Valley, CA 91977",
    "lat": 32.7152269,
    "lng": -117.0135135,
    "geocode_name": "La Moreña Mariscos, 1157, Sweetwater Road, Skyline, Spring Valley, San Diego County, California, 91977, United States"
  },
  {
    "id": 48,
    "name": "Cynthia N. Durousseaux",
    "address": "24006 Lake Drive 2938 Crestline, CA 92325",
    "lat": 37.2742,
    "lng": -79.9579,
    "geocode_name": "ZIP centroid 24006 Roanoke VA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 49,
    "name": "Cytherea Toy Shop",
    "address": "231 E Dyer Rd. Ste F SantaAna, CA 92707",
    "lat": 33.7086,
    "lng": -117.8701,
    "geocode_name": "ZIP centroid 92707 Santa Ana CA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 50,
    "name": "Daniel Sams Boxer and Brief",
    "address": "514 Daniels St PMB# 121 Raleigh, NC 27605",
    "lat": 35.7908,
    "lng": -78.653,
    "geocode_name": "ZIP centroid 27605 Raleigh NC",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 51,
    "name": "DCD Exclusive Video",
    "address": "102-30 Queens Blvd Forest Hills, NY 11375",
    "lat": 40.7250179,
    "lng": -73.8508997,
    "geocode_name": "Vanessa's Dumpling House, 102-30, Queens Boulevard, Forest Hills, Queens, Queens County, New York, 11375, United States"
  },
  {
    "id": 52,
    "name": "DCD Long Island",
    "address": "23-08 JacksonAve Long Island, NY 11101",
    "lat": 40.7446,
    "lng": -73.9345,
    "geocode_name": "ZIP centroid 11101 Long Island City NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 53,
    "name": "Deluxe Distributors",
    "address": "127 Hendy Creek Rd. Pine City, NY 14871",
    "lat": 42.081098,
    "lng": -76.8741903,
    "geocode_name": "127, Hendy Creek Road, Town of Big Flats, Chemung County, New York, 14871, United States"
  },
  {
    "id": 54,
    "name": "Elegant Secrets",
    "address": "3507 S Maryland Pkwy Las Vegas, NV 89169",
    "lat": 36.1442399,
    "lng": -115.1371255,
    "geocode_name": "South Maryland Parkway, Downtown Las Vegas, Las Vegas, Clark County, Nevada, 89104, United States"
  },
  {
    "id": 55,
    "name": "EXOTIC ZONE SHOP",
    "address": "15315 s Figueroa st Unit A Gardena, CA 90248",
    "lat": 39.817,
    "lng": -79.9567,
    "geocode_name": "ZIP centroid 15315 Bobtown PA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 56,
    "name": "Frenzies Adult Novelty Boutique",
    "address": "8028 Florida Blvd., Ste C Denham Springs, LA 70726",
    "lat": 30.459,
    "lng": -90.9027,
    "geocode_name": "ZIP centroid 70726 Denham Springs LA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 57,
    "name": "Jack & Jill Naples",
    "address": "967 Airport-Pulling Rd, Naples, FL 34104",
    "phone": "(239) 643-3355",
    "lat": 26.1619661,
    "lng": -81.7670138,
    "geocode_name": "967, Airport Pulling Road, Naples, Collier County, Florida, 34104, United States"
  },
  {
    "id": 58,
    "name": "Jack & Jill Port Charlotte",
    "address": "2782 Tamiami TRL, Port Charlotte, FL 33952",
    "phone": "941-766-0041",
    "lat": 26.9899716,
    "lng": -82.1094628,
    "geocode_name": "2782, Tamiami Trail, Port Charlotte, Charlotte County, Florida, 33952, United States"
  },
  {
    "id": 59,
    "name": "Jack & Jill St. Pete",
    "address": "3627 Tyrone Blvd, Saint Petersburg, FL 33710",
    "phone": "727-347-1866",
    "lat": 27.8048802,
    "lng": -82.7469173,
    "geocode_name": "3627, Tyrone Boulevard North, Jungle Terrace, Saint Petersburg, Pinellas County, Florida, 33710, United States"
  },
  {
    "id": 60,
    "name": "Jack & Jill Tampa",
    "address": "2314 N Dale Mabry Hwy, Tampa, FL 33607",
    "phone": "813-443-5358",
    "lat": 27.9621657,
    "lng": -82.5059533,
    "geocode_name": "Jack and Jill Express, 2314, North Dale Mabry Highway, Lincoln Gardens, West Tampa, Tampa, Hillsborough County, Florida, 33607, United States"
  },
  {
    "id": 61,
    "name": "Jack & Jill Venice",
    "address": "1622 S Tamiami TRL, Venice, FL 34293",
    "phone": "941-949-6809",
    "lat": 27.0951492,
    "lng": -82.4443303,
    "geocode_name": "South Tamiami Trail, Venice, Sarasota County, Florida, 34285, United States"
  },
  {
    "id": 62,
    "name": "JDS",
    "address": "185 Carlingview Dr 1 Toronto, Ontario M9W 5E8"
  },
  {
    "id": 63,
    "name": "Jennas Toy Box",
    "address": "1101 Gallatin Pike S Madison, TN 37115",
    "lat": 36.2604,
    "lng": -86.7046,
    "geocode_name": "ZIP centroid 37115 Madison TN",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 64,
    "name": "Kech Group",
    "address": "1778 Laporte St Portage, IN 46368",
    "lat": 41.600007,
    "lng": -87.171266,
    "geocode_name": "1778, Laporte Street, Portage, Porter County, Indiana, 46368, United States"
  },
  {
    "id": 65,
    "name": "La Plaza Beauty",
    "address": "1821 S Bicentennial Blvd Mcallen, TX 78503",
    "lat": 26.1881981,
    "lng": -98.2417745,
    "geocode_name": "South Bicentennial Boulevard, McAllen, Hidalgo County, Texas, 78503, United States"
  },
  {
    "id": 66,
    "name": "Love Store México",
    "address": "1765 Stergios Rd Suite101 Calexico, CA 92231",
    "lat": 32.6832,
    "lng": -115.5028,
    "geocode_name": "ZIP centroid 92231 Calexico CA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 67,
    "name": "Love Toys",
    "address": "700 E Jericho Turnpike Huntington Station, NY 11746",
    "lat": 40.8340508,
    "lng": -73.3837503,
    "geocode_name": "700, East Jericho Turnpike, Huntington Station, Town of Huntington, Suffolk County, New York, 11746, United States"
  },
  {
    "id": 68,
    "name": "LoveBird's Paradise",
    "address": "6401 Douglas Avenue Suite 5 Urbandale, IA 50322",
    "lat": 41.6295,
    "lng": -93.723,
    "geocode_name": "ZIP centroid 50322 Urbandale IA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 69,
    "name": "Lovers Outet",
    "address": "8660 San Ysidro ave suite 100 Gilroy, CA 95020",
    "lat": 37.0139,
    "lng": -121.5773,
    "geocode_name": "ZIP centroid 95020 Gilroy CA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 70,
    "name": "Lucy’s Love Shop",
    "address": "2015 Cherry Rd Rock Hill, SC 29732",
    "lat": 34.9624213,
    "lng": -81.0028226,
    "geocode_name": "2015, North Cherry Road, Kenilworth Acres, Rock Hill, York County, South Carolina, 29732, United States"
  },
  {
    "id": 71,
    "name": "Lucy's Love Shop",
    "address": "3241 Washington Rd Suite J Augusta, GA 30907",
    "lat": 33.5229,
    "lng": -82.0852,
    "geocode_name": "ZIP centroid 30907 Augusta GA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 72,
    "name": "Megaplexx",
    "address": "7111 IH 35 South Austin, TX 78744",
    "lat": 30.1876,
    "lng": -97.7472,
    "geocode_name": "ZIP centroid 78744 Austin TX",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 73,
    "name": "Miami Distro",
    "address": "23084 L'Ermitage Cir. Boca Raton, FL 33433",
    "lat": 37.8942,
    "lng": -78.1208,
    "geocode_name": "ZIP centroid 23084 Kents Store VA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 74,
    "name": "Milbar Adult Store",
    "address": "67 Milbar Blvd. Farmingdale, NY 11735",
    "lat": 40.7504196,
    "lng": -73.4198507,
    "geocode_name": "67, Milbar Boulevard, East Farmingdale, Town of Babylon, Suffolk County, New York, 11735, United States"
  },
  {
    "id": 75,
    "name": "MJM Novelty Sales",
    "address": "3318 Second St. East Cornwall, ON K6H 6J8"
  },
  {
    "id": 76,
    "name": "National Video Supply",
    "address": "21100 Centre Pointe Pkwy Santa Clarita, CA 91350",
    "lat": 34.412374,
    "lng": -118.503575,
    "geocode_name": "21100, Centre Pointe Parkway, Santa Clarita, Los Angeles County, California, 91350, United States"
  },
  {
    "id": 77,
    "name": "Naughty, A Couple's Boutique",
    "address": "1005 RT 22 W North Plainfield, NJ 07060",
    "lat": 40.6152,
    "lng": -74.415,
    "geocode_name": "ZIP centroid 07060 Plainfield NJ",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 78,
    "name": "Naughty Boutique",
    "address": "2540-A RT. 22 West UNION, NJ 07083",
    "lat": 40.6952,
    "lng": -74.2677,
    "geocode_name": "ZIP centroid 07083 Union NJ",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 79,
    "name": "Naughty Nancy's",
    "address": "60 Connecticut Ave. Norwalk, CT 06850",
    "lat": 41.1076321,
    "lng": -73.4225982,
    "geocode_name": "60, Connecticut Avenue, South Norwalk, East Norwalk, Norwalk, Western Connecticut Planning Region, Connecticut, 06850, United States"
  },
  {
    "id": 80,
    "name": "New FineArts",
    "address": "12045 Shiloh Rd Dallas, TX 75228",
    "lat": 32.8613173,
    "lng": -96.6662049,
    "geocode_name": "12045, Shiloh Road, Zacha Junction, Dallas, Dallas County, Texas, 75041, United States"
  },
  {
    "id": 81,
    "name": "New FineArts",
    "address": "1720 W Mockingbird Ln Dallas, TX 75235",
    "lat": 32.8217869,
    "lng": -96.8560481,
    "geocode_name": "New Fine Arts Adult Megastore & Smoke Shop, 1720, West Mockingbird Lane, Dallas, Dallas County, Texas, 75235, United States"
  },
  {
    "id": 82,
    "name": "New FineArts",
    "address": "1966 W Northwest Hwy Dallas, TX 75220",
    "lat": 32.8675175,
    "lng": -96.9106983,
    "geocode_name": "New Fine Arts Adult Video, 1966, West Northwest Highway, Highland, Dallas, Dallas County, Texas, 75220, United States"
  },
  {
    "id": 83,
    "name": "Nitecap",
    "address": "690 Gulf Ave Staten Island, NY 10314",
    "lat": 40.613486,
    "lng": -74.1807658,
    "geocode_name": "690, Gulf Avenue, Bloomfield, Staten Island, Richmond County, New York, 10314, United States"
  },
  {
    "id": 84,
    "name": "Our Secret Intimacy Shop",
    "address": "31918 Rio vista Rd Parker, AZ 85344"
  },
  {
    "id": 85,
    "name": "Out of Bounds",
    "address": "1608 Easley Bridge Rd Greenville, SC 29611",
    "lat": 34.8357489,
    "lng": -82.4381533,
    "geocode_name": "1608, Easley Bridge Road, Welcome, Greenville County, South Carolina, 29611, United States"
  },
  {
    "id": 86,
    "name": "Party Time James Gotham Video",
    "address": "40 Entin Rd. Clifton, New Jersey",
    "lat": 40.8329082,
    "lng": -74.1248798,
    "geocode_name": "40, Entin Road, Clifton, Passaic County, New Jersey, 07014, United States"
  },
  {
    "id": 87,
    "name": "Rainbow Station",
    "address": "858 Lakewood Rd Suite B WaterBury, CT 06074",
    "lat": 41.8341,
    "lng": -72.5576,
    "geocode_name": "ZIP centroid 06074 South Windsor CT",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 88,
    "name": "Rashed",
    "address": "327 Yonkers Ave Sunoco Gas Station Yonkers, Ny 10701",
    "lat": 40.9461,
    "lng": -73.8669,
    "geocode_name": "ZIP centroid 10701 Yonkers NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 89,
    "name": "Romantix",
    "address": "12686 Garden Grove Blvd, Garden Grove, CA 92843",
    "lat": 33.774604,
    "lng": -117.9130277,
    "geocode_name": "12686, Garden Grove Boulevard, Garden Grove, Orange County, California, 92843, United States"
  },
  {
    "id": 90,
    "name": "Rough Trade Leather & Gear",
    "address": "3915 W Sunset Blvd Los Angeles, CA 90029",
    "lat": 34.0922418,
    "lng": -118.2798321,
    "geocode_name": "3915, West Sunset Boulevard, Sunset Junction, Silver Lake, Los Angeles, Los Angeles County, California, 90029, United States"
  },
  {
    "id": 91,
    "name": "Ryan Enright Reliable Consultants Inc",
    "address": "7821 N. IH 35 Austin, TX 78753",
    "lat": 30.3648,
    "lng": -97.6827,
    "geocode_name": "ZIP centroid 78753 Austin TX",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 92,
    "name": "Secret Expression",
    "address": "2400 N OceanAve, Suite B Farmingville, NY 11738",
    "lat": 40.8366,
    "lng": -73.0412,
    "geocode_name": "ZIP centroid 11738 Farmingville NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 93,
    "name": "Sexshop Matamoros",
    "address": "3200 Resaca Vista Dr Brownville, TX 78526",
    "lat": 25.9717,
    "lng": -97.4699,
    "geocode_name": "ZIP centroid 78526 Brownsville TX",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 94,
    "name": "SIN-A-YOUN",
    "address": "245 E Redondo Beach Gardena, CA 90248",
    "lat": 33.8924758,
    "lng": -118.2918598,
    "geocode_name": "West Redondo Beach Boulevard, Gardena, Los Angeles County, California, 90247, United States"
  },
  {
    "id": 95,
    "name": "SOUTHWEST RETAIL Development",
    "address": "15803 US-59 Humble, TX 77396",
    "lat": 29.972866,
    "lng": -95.2809926,
    "geocode_name": "Eastex Freeway, Houston, Harris County, Texas, 77396, United States"
  },
  {
    "id": 96,
    "name": "SUSTAINABLE PASSION",
    "address": "311 N Meadow St Ithaca, NY 14850",
    "lat": 42.4416497,
    "lng": -76.5082098,
    "geocode_name": "311, North Meadow Street, West End, Ward 2, City of Ithaca, Tompkins County, New York, 14850, United States"
  },
  {
    "id": 97,
    "name": "TAF Distribution",
    "address": "6180 W. Gowen Rd. Boise, ID 83709",
    "lat": 43.5601515,
    "lng": -116.2575715,
    "geocode_name": "6180, West Gowen Road, Randall Acres, Boise, Ada County, Idaho, 83709, United States"
  },
  {
    "id": 98,
    "name": "The Ladies Room",
    "address": "128 Montgomery Mall North Wales, PA 19454",
    "lat": 40.2166,
    "lng": -75.2565,
    "geocode_name": "ZIP centroid 19454 North Wales PA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 99,
    "name": "The Rolling O",
    "address": "6009 Shelane Ct. Raleigh, NC 27610",
    "lat": 35.7380746,
    "lng": -78.5382542,
    "geocode_name": "6009, Shelane Court, Chastain, Raleigh, Wake County, North Carolina, 27620, United States"
  },
  {
    "id": 100,
    "name": "The Toy Box",
    "address": "1999 WArrow Rte Upland, CA 91786",
    "lat": 34.1144,
    "lng": -117.6583,
    "geocode_name": "ZIP centroid 91786 Upland CA",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 101,
    "name": "Vishara",
    "address": "781 8thAve. New York, NY 10036",
    "lat": 40.7597,
    "lng": -73.9918,
    "geocode_name": "ZIP centroid 10036 New York City NY",
    "geocode_level": "zip_centroid"
  },
  {
    "id": 102,
    "name": "Vixen Video Boise",
    "address": "5777 W Overland Rd, Boise, ID 83705",
    "phone": "208-672-1844",
    "lat": 43.5890913,
    "lng": -116.2530705,
    "geocode_name": "Vixen Video, 5777, West Overland Road, Boise, Ada County, Idaho, 83705, United States"
  },
  {
    "id": 103,
    "name": "Williams Trading",
    "address": "9250 Commerce Hwy Pennsauken Township, NJ 08110",
    "lat": 39.9791622,
    "lng": -75.0243003,
    "geocode_name": "9250, Commerce Highway, East Pennsauken, Pennsauken Township, Camden County, New Jersey, 08110, United States"
  },
  {
    "id": 104,
    "name": "XXXPosed",
    "address": "93 Londonderry Turnpike Hooksett, NH 03106",
    "lat": 43.0144724,
    "lng": -71.3992579,
    "geocode_name": "93, Londonderry Turnpike, Hooksett, Merrimack County, New Hampshire, 03106, United States"
  },
  {
    "id": 105,
    "name": "Yehuda Kazab La Plaza Beauty",
    "address": "1821 S Bicentennial Blvd Mcallen, TX 78503",
    "lat": 26.1881981,
    "lng": -98.2417745,
    "geocode_name": "South Bicentennial Boulevard, McAllen, Hidalgo County, Texas, 78503, United States"
  }
];

window.OEJ_STORE_LOCATOR_META = {
  "source": "Shops_carry_OEJ.xlsx + TAF_Locations_2026_2.xlsx",
  "count": 105,
  "geocoded": 102,
  "missing_geocode": [
    {
      "name": "JDS",
      "address": "185 Carlingview Dr 1 Toronto, Ontario M9W 5E8"
    },
    {
      "name": "MJM Novelty Sales",
      "address": "3318 Second St. East Cornwall, ON K6H 6J8"
    },
    {
      "name": "Our Secret Intimacy Shop",
      "address": "31918 Rio vista Rd Parker, AZ 85344"
    }
  ],
  "last_import": "TAF_Locations_2026_2.xlsx",
  "last_import_added": 37,
  "last_import_duplicates_skipped": 0
};

/* OEJ_PRODUCT_ZIP_REDIRECT_HANDLER_20260708 */
(function(){
  if (window.__oejProductZipRedirectHandler) return;
  window.__oejProductZipRedirectHandler = true;
  function validZip(zip){ return /^\d{5}(?:-\d{4})?$/.test(zip); }
  function redirectFromWidget(widget, zip){
    var pageUrl = widget.getAttribute('data-store-url') || '/pages/stores';
    var params = new URLSearchParams();
    if (zip) params.set('zip', zip);
    params.set('product', widget.getAttribute('data-product-handle') || '');
    if (widget.getAttribute('data-product-sku')) params.set('sku', widget.getAttribute('data-product-sku'));
    try {
      if (zip) sessionStorage.setItem('oej_find_store_zip', zip);
      sessionStorage.setItem('oej_find_store_product', widget.getAttribute('data-product-title') || '');
      sessionStorage.setItem('oej_find_store_handle', widget.getAttribute('data-product-handle') || '');
      sessionStorage.setItem('oej_find_store_sku', widget.getAttribute('data-product-sku') || '');
    } catch(e) {}
    window.location.href = pageUrl + '?' + params.toString() + '#OejStoreResults';
  }
  document.addEventListener('submit', function(event){
    var form = event.target && event.target.closest && event.target.closest('[data-oej-find-store-form]');
    if (!form) return;
    event.preventDefault();
    var widget = form.closest('[data-oej-find-store]');
    var input = form.querySelector('[data-oej-find-store-zip]');
    var note = widget && widget.querySelector('[data-oej-find-store-note]');
    var zip = (input && input.value || '').trim();
    if (!validZip(zip)) {
      if (note) {
        note.textContent = 'Please enter a valid 5-digit ZIP code.';
        note.classList.add('is-error');
      }
      if (input) input.focus();
      return;
    }
    redirectFromWidget(widget || form, zip);
  }, true);
  document.addEventListener('click', function(event){
    var toggle = event.target && event.target.closest && event.target.closest('[data-oej-find-store-toggle]');
    if (!toggle) return;
    var widget = toggle.closest('[data-oej-find-store]');
    var input = widget && widget.querySelector('[data-oej-find-store-zip]');
    var zip = (input && input.value || '').trim();
    if (validZip(zip)) {
      event.preventDefault();
      redirectFromWidget(widget, zip);
    } else if (input) {
      event.preventDefault();
      input.focus();
    }
  }, true);
})();

/* OEJ_PICKUP_SANDBOX_20260709_START */
(function(){
  var params = new URLSearchParams(window.location.search || '');
  var sandboxMode = params.get('pickup_sandbox');
  var locatorMode = sandboxMode === 'curious-adameve-25mi';
  var laLocatorMode = sandboxMode === '91601-two-stores' || sandboxMode === '91505-two-stores';
  var productMode = sandboxMode === 'curious-adameve-product';
  var laProductMode = productMode && params.get('pickup_market') === '91601';
  var activeRadius = (laLocatorMode || laProductMode) ? 10 : 25;
  var activeStoreLimit = (laLocatorMode || laProductMode) ? 2 : 1;
  if (!locatorMode && !laLocatorMode && !productMode) return;
  window.__OEJ_PICKUP_SANDBOX_ACTIVE = true;
  window.__OEJ_PICKUP_PRODUCT_TESTER_ACTIVE = productMode;
  var stores = [{"name":"Le Sex Shoppe","address":"4877 Lankershim Blvd, North Hollywood, CA 91601","phone":"","lat":34.1593734,"lng":-118.3714013},{"name":"Sherman Way Adult Book Store","address":"11841 Sherman Way, North Hollywood, CA 91605","phone":"818-765-1217","lat":34.201279,"lng":-118.3914078},{"name":"Secrets of Hollywood","address":"1117 N Western Ave, Los Angeles, CA 90029","phone":"323-467-1640","lat":34.0918549,"lng":-118.3090864},{"name":"Endless Romance Adult Superstore","address":"8722 Santa Monica Blvd, West Hollywood, CA 90069","phone":"310-573-8666","lat":34.086984,"lng":-118.3805035},{"name":"Adult Warehouse Outlet Panorama","address":"8126 Van Nuys Blvd #2, Panorama City, CA 91402","phone":"818-985-2255","lat":34.2187986,"lng":-118.4482349},{"name":"Adult Factory Outlet - Sex Store & Shop","address":"12907 Foothill Blvd, Sylmar, CA 91342","phone":"818-336-9440","lat":34.2942093,"lng":-118.4158293},{"name": "Adam & Eve Boise", "address": "6919 W Fairview Ave, Boise, ID 83704", "phone": "208-376-0068", "lat": 43.6188782, "lng": -116.2680321}, {"name": "Adam & Eve Nampa", "address": "4213 Garrity Blvd, Nampa, ID 83687", "phone": "208-461-4676", "lat": 43.594337, "lng": -116.5184273}, {"name": "Adam & Eve Coeur d'Alene", "address": "348 W Bosanko Ave # D, Coeur d'Alene, ID 83815", "phone": "208-664-1400", "lat": 47.7115839, "lng": -116.7908619}, {"name": "Adam & Eve Pocatello", "address": "657 N Main St, Pocatello, ID 83204", "phone": "208-235-9457", "lat": 42.8662504, "lng": -112.4555393}, {"name": "Adam & Eve Idaho Falls", "address": "118 1st Street, Idaho Falls, ID 83401", "phone": "208-242-3948", "lat": 43.4970457, "lng": -112.0325615}, {"name": "Adam & Eve Omaha", "address": "3507 S 84th St, Omaha, NE 68124", "phone": "986-218-9427", "lat": 41.226201, "lng": -96.043028}, {"name": "Adam & Eve Portland", "address": "9220 SW Barbur Blvd Suite #115, Portland, OR 97219", "phone": "503-244-1604", "lat": 45.4587374, "lng": -122.7088101}, {"name": "Adam & Eve Downtown Denver", "address": "1331 E Colfax Ave, Denver CO 80218", "phone": "303-529-2547", "lat": 39.7403801, "lng": -104.9700598}, {"name": "Adam & Eve Spokane", "address": "3609 N Division St Suite A, Spokane, WA 99207", "phone": "509-290-6435", "lat": 47.6913588, "lng": -117.4116144}, {"name": "Adam & Eve Denver South", "address": "4697 E Evans Ave Suite 103, Denver, CO 80222", "phone": "720-734-3778", "lat": 39.6788046, "lng": -104.932485}, {"name": "Adam & Eve Twin Falls", "address": "1111 Blue Lakes Blvd N Unit F, Twin Falls, ID 83301", "phone": "208-595-2398", "lat": 42.5820456, "lng": -114.4603775}, {"name": "Adam & Eve Cheyenne", "address": "2115 E Lincolnway, Cheyenne, WY 82001", "phone": "307-227-2252", "lat": 41.1383546, "lng": -104.79238}, {"name": "Adam & Eve Lincoln", "address": "4327 E O St, Lincoln, NE 68510", "phone": "402-256-6654", "lat": 40.8138574, "lng": -96.6104219}, {"name": "Adam & Eve Joplin", "address": "108 N Rangeline Rd, Joplin, MO 64801", "phone": "986-218-9431", "lat": 37.0937492, "lng": -94.4769739}, {"name": "Adam & Eve Sarasota", "address": "4400 S Tamiami Trail, Sarasota, FL 34231", "phone": "941-263-0345", "lat": 27.290291, "lng": -82.530753}, {"name": "Adam & Eve Pullman", "address": "205 NW Whitman St Pullman, WA 99163", "phone": "509-584-4419‬", "lat": 46.732605, "lng": -117.1803526}, {"name": "Adam & Eve Meridian", "address": "1327 East Fairview Ave MERIDIAN, ID 83642", "phone": "208-609-9250‬", "lat": 43.6190451, "lng": -116.3779938}, {"name": "Adam & Eve Duluth", "address": "2116 Maple Grove Rd, Duluth, MN 55811", "phone": "218-522-4556", "lat": 46.8072793, "lng": -92.1647131}, {"name": "Adam & Eve Madison", "address": "6807 Odana Rd, Madison, WI 53719", "phone": "608-820-1655", "lat": 43.0562598, "lng": -89.4993003}, {"name": "Adam & Eve Sugarhouse", "address": "2153 S 700 E, Salt Lake City, UT 84106", "phone": "385-261-2972", "lat": 40.724091, "lng": -111.870993}, {"name": "Adam & Eve West Valley", "address": "3443 W 3500 S, West Valley City, UT 84119", "phone": "801-999-4719", "lat": 40.6965909, "lng": -111.9808255}, {"name": "Adam & Eve Bangor", "address": "657 Broadway, Bangor, ME 04401", "phone": "(207) 401-4736", "lat": 44.823378, "lng": -68.778837}, {"name": "Adam & Eve Killeen", "address": "3800 E Stan Schlueter Loop, Killeen, TX 76542", "phone": "(254) 312-8188", "lat": 31.0702662, "lng": -97.7110914}, {"name": "Adam & Eve Ogden", "address": "3531 Harrison Blvd, Ogden, UT 84403", "phone": "986.278.1386", "lat": 41.1988536, "lng": -111.948832}, {"name": "Adam & Eve Old Port", "address": "424 Fore St, Portland, ME 04101", "phone": "(207) 871-0356", "lat": 43.6559187, "lng": -70.2540738}, {"name": "Adam & Eve Bend", "address": "1531 NE 3rd St, Bend, OR 97701", "phone": "(986)213-3179", "lat": 44.0655715, "lng": -121.3029704}, {"name": "Adam & Eve Casper", "address": "4709 W Yellowstone Hwy, Mills, WY 82604", "phone": "(307)922-0176", "lat": 42.8514678, "lng": -106.3841558}, {"name": "Adam & Eve Kalispell", "address": "280 2nd Ave E N, Kalispell, MT 59901", "phone": "(406)755-8369", "lat": 48.202158, "lng": -114.315321}];
  /* OEJ_STORE_LOGO_CONFIG_START */
  // Optional per-store field: store.logo = 'https://...'; store.logoAlt = 'Store logo'.
  // Brand fallback below applies to every Adam & Eve location unless overridden.
  var storeBrandLogos = {
    'adam & eve': { src: "https://cdn.shopify.com/s/files/1/0843/7835/3965/t/30/assets/oej-store-logo-adam-eve.jpg?v=1783733644", alt: 'Adam & Eve' }
  };
  function logoForStore(store){
    if (!store) return null;
    if (store.logo) return {src:store.logo,alt:store.logoAlt || store.name};
    var name=String(store.name || '').toLowerCase();
    var keys=Object.keys(storeBrandLogos);
    for(var i=0;i<keys.length;i++) if(name.indexOf(keys[i])!==-1) return storeBrandLogos[keys[i]];
    return null;
  }
  function storeLogoHtml(store){
    if(!store) return '';
    var logo=logoForStore(store);
    if(logo && logo.src) return `<div class="oej-pick-populated-logo" aria-label="${esc(store.name)} store logo"><img src="${esc(logo.src)}" alt="${esc(logo.alt || store.name)}" loading="eager"><small>Available at ${esc(store.name)}</small></div>`;
    return `<div class="oej-pick-populated-logo is-fallback"><strong>${esc(store.name)}</strong><small>Retail location</small></div>`;
  }
  /* OEJ_STORE_LOGO_CONFIG_END */
  var products = [{"title": "Bottom Line Silicone Anal Beads", "handle": "bottom-line-silicone-anal-beads", "url": "/products/bottom-line-silicone-anal-beads", "price": "27.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Bottom_Line_Silicone_Anal_Beads.jpg?v=1778881303"}, {"title": "Bubbly Bullet Vibrator", "handle": "bubbly-bullet-vibrator", "url": "/products/bubbly-bullet-vibrator", "price": "42.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Bubbly_Bullet_Vibrator.jpg?v=1778881304"}, {"title": "Buzzy Bullet Vibrator", "handle": "buzzy-bullet-vibrator", "url": "/products/buzzy-bullet-vibrator", "price": "42.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Buzzy_Bullet_Vibrator.jpg?v=1778881323"}, {"title": "Enchantress Palm Massager", "handle": "enchantress", "url": "/products/enchantress", "price": "58.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Enchantress_Palm_Massager.png?v=1778881362"}, {"title": "Level Up Anal Trainers 3 Piece Silicone Anchor Set", "handle": "level-up-anal-trainers-set", "url": "/products/level-up-anal-trainers-set", "price": "39.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Level_Up_Anal_Trainers_3_Piece_Silicone_Anchor_Set.jpg?v=1778881543"}, {"title": "Level Up II Anal Trainers 3 Piece Silicone Suction Set", "handle": "level-up-anal-trainers-silicone-suction-set", "url": "/products/level-up-anal-trainers-silicone-suction-set", "price": "37.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Level_Up_II_Anal_Trainers_3_Piece_Silicone_Suction_Set.jpg?v=1778881562"}, {"title": "Little Secret Dual Action Air Suction Mini Massager", "handle": "little-secret", "url": "/products/little-secret", "price": "58.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Little_Secret_Dual_Action_Air_Suction_Mini_Massager.png?v=1778881566"}, {"title": "Pleasure Pen Slim Vibrator", "handle": "pleasure-pen", "url": "/products/pleasure-pen", "price": "42.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Pleasure_Pen_Slim_Vibrator.jpg?v=1778881645"}, {"title": "Scarlett Kiss Silicone Lipstick Vibrator", "handle": "scarlett-kiss-silicone-lipstick-vibrator", "url": "/products/scarlett-kiss-silicone-lipstick-vibrator", "price": "37.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Scarlett_Kiss_Silicone_Lipstick_Vibrator.jpg?v=1778881720"}, {"title": "Spot On Rechargeable Wand", "handle": "spot-on", "url": "/products/spot-on", "price": "52.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Spot_On_Rechargeable_Wand_Purple_2.jpg?v=1778881903"}, {"title": "Spot On Rechargeable Wand Purple", "handle": "spot-on-rechargeable-wand-purple", "url": "/products/spot-on-rechargeable-wand-purple", "price": "52.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Spot_On_Rechargeable_Wand_Purple.png?v=1778881903"}, {"title": "Tickled Licker Massager", "handle": "tickled-licker-massager", "url": "/products/tickled-licker-massager", "price": "66.99", "image": "https://cdn.shopify.com/s/files/1/0843/7835/3965/files/Tickled_Licker_Massager.jpg?v=1778881949"}];
  var defaultOrigin = { label:'83704 · Boise, ID', lat:43.6188782, lng:-116.2680321 };
  var origins = {
    '91601': { label:'91601 · North Hollywood, CA', lat:34.1664501, lng:-118.3731572 },
    'north hollywood': { label:'91601 · North Hollywood, CA', lat:34.1664501, lng:-118.3731572 },
    '91505': { label:'91505 · Burbank, CA', lat:34.1690113, lng:-118.3426986 },
    'burbank': { label:'91505 · Burbank, CA', lat:34.1690113, lng:-118.3426986 },
    '83704': defaultOrigin,
    'boise': defaultOrigin,
    'nampa': { label:'83687 · Nampa, ID', lat:43.594337, lng:-116.5184273 },
    '83815': { label:'83815 · Coeur d’Alene, ID', lat:47.7115839, lng:-116.7908619 },
    '80202': { label:'80202 · Denver, CO', lat:39.7392, lng:-104.9903 },
    '04401': { label:'04401 · Bangor, ME', lat:44.8016, lng:-68.7712 }
  };
  function esc(s){ return String(s || '').replace(/[&<>\"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c] || c; }); }
  function miles(aLat,aLng,bLat,bLng){ var R=3958.8,toRad=function(d){return d*Math.PI/180;}; var dLat=toRad(bLat-aLat),dLng=toRad(bLng-aLng); var s1=Math.sin(dLat/2)**2; var s2=Math.cos(toRad(aLat))*Math.cos(toRad(bLat))*Math.sin(dLng/2)**2; return 2*R*Math.asin(Math.sqrt(s1+s2)); }
  function mapsUrl(store, dir){ var q=encodeURIComponent(store.address); return dir ? 'https://www.google.com/maps/dir/?api=1&destination='+q : 'https://www.google.com/maps/search/?api=1&query='+q; }
  function nearest(origin){ return stores.map(function(s){ var d=miles(origin.lat,origin.lng,s.lat,s.lng); return Object.assign({},s,{distance:d}); }).sort(function(a,b){return a.distance-b.distance;}); }
  function productHtml(p){ return `<a class="oej-pick-product-link" href="${esc(p.url)}?pickup_sandbox=curious-adameve-product${laLocatorMode ? '&pickup_market=91601' : ''}" aria-label="Open ${esc(p.title)} pickup tester"><article class="oej-pick-product"><img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy"><h3>${esc(p.title)}</h3><p>$${esc(p.price)}</p><span>Mock inventory: 10</span><b>Test pickup on product page →</b></article></a>`; }
  function storeHtml(s){ return `<article><strong>${esc(s.name)}</strong><p>${esc(s.address)}</p><span>${s.distance.toFixed(1)} mi away</span><a href="${mapsUrl(s,true)}" target="_blank" rel="noopener">Get Directions</a></article>`; }
  function render(origin, expanded){
    var oldBar=document.querySelector('.oej-pick-sticky'); if(oldBar) oldBar.remove();
    var displayRadius=(laLocatorMode && expanded)?25:activeRadius;
    var allInRange=nearest(origin).filter(function(s){return s.distance<=displayRadius;});
    var eligible=(laLocatorMode && !expanded)?allInRange.slice(0,activeStoreLimit):allInRange;
    var bannerStores=laLocatorMode?allInRange.slice(0,1):eligible.slice(0,1), pickup=bannerStores[0];
    var ranked=nearest(origin);
    try { sessionStorage.setItem('oej_pickup_sandbox_origin', JSON.stringify(origin)); } catch(e) {}
    var root=document.querySelector('main') || document.body;
    root.innerHTML='<div class="oej-pickup-sandbox" data-oej-pickup-sandbox></div>';
    var el=root.querySelector('[data-oej-pickup-sandbox]');
    el.innerHTML = `
      <section class="oej-pick-hero">
        <p class="oej-pick-eyebrow">Private OEJ sandbox · not real inventory</p>
        <h1>Soft pickup banner test</h1>
        ${pickup ? storeLogoHtml(pickup) : ''}
        <p>This hidden test URL mocks <strong>10 pieces of inventory</strong> for every Curious Collection product at ${laLocatorMode ? 'the two closest adult-store test locations near 91601' : 'the Adam & Eve locations from the latest TAF list'}. It lets us test the “Pick up here” experience before connecting live store inventory.</p>
        <form class="oej-pick-search" data-pick-search>
          <input name="q" value="${esc(origin.label)}" aria-label="Test ZIP or city" placeholder="Try 83704, Boise, Nampa, 80202">
          <button type="submit">Test location</button>
        </form>
        <div class="oej-pick-status">Showing mock availability near <strong>${esc(origin.label)}</strong> · threshold: <strong>${displayRadius} miles</strong></div>
      </section>
      <section class="oej-pick-grid">
        <div class="oej-pick-panel"><p class="oej-pick-eyebrow">Banner behavior</p><h2>${eligible.length ? (eligible.length===1 ? 'Pickup option found' : 'Two pickup options found') : `No pickup store inside ${activeRadius} miles`}</h2>${eligible.length ? eligible.map(function(store,index){return `<p><strong>${index+1}. ${esc(store.name)}</strong> · ${store.distance.toFixed(1)} miles away</p><a class="oej-pick-btn" href="${mapsUrl(store,true)}" target="_blank" rel="noopener">Directions to ${esc(store.name)}</a>`;}).join('') : '<p>The sticky banner stays hidden when there is no store inside the radius.</p>'}${laLocatorMode && !expanded ? '<button type="button" class="oej-pick-btn oej-pick-more" data-find-more-stores>Find More Stores</button>' : ''}</div>
        <div class="oej-pick-panel"><p class="oej-pick-eyebrow">Mock inventory rule</p><h2>Curious Collection only</h2><p>Every Curious Collection product below shows <strong>10 available</strong> for the nearest eligible ${laLocatorMode ? '91601 test stores' : 'Adam & Eve store'}. No other collections are included in this test.</p></div>
      </section>
      <section class="oej-pick-products"><p class="oej-pick-eyebrow">Curious Collection</p><h2>Products with mock pickup inventory</h2><div class="oej-pick-product-grid">${products.map(productHtml).join('')}</div></section>
      <section class="oej-pick-stores" id="stores"><p class="oej-pick-eyebrow">${laLocatorMode ? 'Stores within 25 miles' : 'Adam & Eve test stores'}</p><h2>Nearest store results</h2><div class="oej-pick-store-grid">${(laLocatorMode ? ranked.filter(function(store){return store.distance<=25;}) : ranked.slice(0,8)).map(storeHtml).join('')}</div></section>`;
    var moreButton=el.querySelector('[data-find-more-stores]');if(moreButton)moreButton.addEventListener('click',function(){var storesSection=document.querySelector('.oej-pick-stores');if(storesSection)storesSection.scrollIntoView({behavior:'smooth',block:'start'});});
    if(bannerStores.length){
      var bar=document.createElement('aside');
      bar.className='oej-pick-sticky';
      var bannerTitle=laLocatorMode ? `Hurry — only 3 left at ${esc(bannerStores[0].name)}` : (bannerStores.length===1 ? `Pick up at ${esc(bannerStores[0].name)}` : `Two closest pickup stores near ${esc(origin.label)}`);
      var bannerDetail=laLocatorMode ? `${bannerStores[0].distance.toFixed(1)} mi away · Mock inventory for the product you’re viewing · Call ahead before visiting` : bannerStores.map(function(store,index){return `${index+1}. ${esc(store.name)} · ${store.distance.toFixed(1)} mi`;}).join(' &nbsp; | &nbsp; ')+' · Mock inventory · Call ahead before visiting';
      var bannerLinks=bannerStores.map(function(store,index){return `<a href="${mapsUrl(store,true)}" target="_blank" rel="noopener">${bannerStores.length===1?'Directions':'Directions '+(index+1)}</a>`;}).join('');
      bar.innerHTML=`<button type="button" aria-label="Close pickup banner">×</button><div><span>♡ Available nearby</span><strong>${bannerTitle}</strong><small>${bannerDetail}</small></div>${bannerLinks}<a href="#stores">View Stores</a>`;
      document.body.appendChild(bar);
      bar.querySelector('button').addEventListener('click',function(){bar.remove();});
    }
    el.querySelector('[data-pick-search]').addEventListener('submit',function(ev){
      ev.preventDefault();
      var raw=(this.q.value||'').toLowerCase().trim();
      var zipMatch=raw.match(/\b\d{5}\b/);
      var key=zipMatch ? zipMatch[0] : raw.replace(/[^a-z0-9 ]/g,'').replace(/\s+/g,' ').trim();
      var found=origins[key] || origins[raw] || origins[raw.replace(/[^a-z0-9]/g,'')];
      if(!found){
        found=laLocatorMode ? origins['91601'] : defaultOrigin;
        alert(laLocatorMode ? 'Enter 91601 or North Hollywood for this sandbox. Resetting to 91601.' : 'Sandbox only knows: 83704, Boise, Nampa, 83815, 80202, 04401. Resetting to Boise.');
      }
      render(found);
    });
  }
  function pickupBar(pickups, product){
    var old=document.querySelector('.oej-pick-sticky'); if(old) old.remove();
    pickups=Array.isArray(pickups)?pickups:(pickups?[pickups]:[]);if(laProductMode)pickups=pickups.slice(0,1);if(!pickups.length) return null;
    var bar=document.createElement('aside');bar.className='oej-pick-sticky oej-pick-sticky--product';
    var item=product ? esc(product.title) : 'Curious Collection';
    var title=laProductMode?`Hurry — only 3 left at ${esc(pickups[0].name)}`:(pickups.length===1?`Pick up at ${esc(pickups[0].name)}`:'Two closest pickup stores');
    var detail=laProductMode?`${item} · ${pickups[0].distance.toFixed(1)} mi away · Mock inventory · Call ahead`:pickups.map(function(store,index){return `${index+1}. ${esc(store.name)} · ${store.distance.toFixed(1)} mi`;}).join(' &nbsp; | &nbsp; ')+` · Mock inventory available for ${item} · Call ahead`;
    var links=pickups.map(function(store,index){return `<a href="${mapsUrl(store,true)}" target="_blank" rel="noopener">${pickups.length===1?'Directions':'Directions '+(index+1)}</a>`;}).join('');
    bar.innerHTML=`<button type="button" aria-label="Close pickup banner">×</button><div><span>♡ Available nearby</span><strong>${title}</strong><small>${detail}</small></div>${links}<a href="/pages/stores?pickup_sandbox=${laProductMode?'91601-two-stores':'curious-adameve-25mi'}#stores">View Stores</a>`;
    document.body.appendChild(bar);bar.querySelector('button').addEventListener('click',function(){bar.remove();});return bar;
  }
  function savedOrigin(){
    try { var raw=sessionStorage.getItem('oej_pickup_sandbox_origin'); if(raw){var o=JSON.parse(raw);if(Number.isFinite(o.lat)&&Number.isFinite(o.lng))return o;} } catch(e) {}
    return null;
  }
  function saveAndShowProductOrigin(origin,product){
    try { sessionStorage.setItem('oej_pickup_sandbox_origin',JSON.stringify(origin)); } catch(e) {}
    var pickups=nearest(origin).filter(function(s){return s.distance<=activeRadius;}).slice(0,activeStoreLimit);
    pickupBar(pickups,product);
    var note=document.querySelector('[data-oej-product-pickup-test-note]');
    if(note) note.textContent=pickups.length ? `Mock pickup found at ${pickups.map(function(x){return x.name;}).join(' and ')}.` : `No mock pickup store found within ${activeRadius} miles.`;
    return pickups.length;
  }
  function productLocationPrompt(product){
    if(document.querySelector('[data-oej-product-pickup-prompt]'))return;
    var prompt=document.createElement('aside');prompt.className='oej-product-pickup-prompt';prompt.setAttribute('data-oej-product-pickup-prompt','');
    prompt.innerHTML=`<strong>Find mock pickup near you</strong><span data-oej-product-pickup-test-note>${laProductMode?'Test location: 91601 · North Hollywood, CA.':'Use your location or enter a test ZIP.'}</span><button type="button" class="oej-product-pickup-get-now" data-oej-get-it-now>${laProductMode?'FIND YOUR STORE':'GET IT NOW'}</button><em>or enter your ZIP code</em><form><input inputmode="numeric" maxlength="5" placeholder="ZIP code" aria-label="Test ZIP code"${laProductMode?' value="91601"':''}><button type="submit">Check pickup</button></form>`;
    var target=document.querySelector('form[action*="/cart/add"]') || document.querySelector('main');if(target)target.insertAdjacentElement('afterend',prompt);else document.body.appendChild(prompt);
    prompt.querySelector('[data-oej-get-it-now]').addEventListener('click',function(){
      if(laProductMode){window.location.href='/pages/stores?pickup_sandbox=91601-two-stores';return;}
      var button=this;
      var note=prompt.querySelector('[data-oej-product-pickup-test-note]');
      if(!navigator.geolocation){note.textContent='Location is unavailable in this browser. Enter your ZIP below.';return;}
      button.disabled=true;button.textContent='FINDING YOUR STORE…';note.textContent='Checking your location for the closest mock-inventory store…';
      var recovery=setTimeout(function(){if(!button.isConnected)return;button.disabled=false;button.textContent='GET IT NOW';note.textContent='Location lookup timed out. Enter your ZIP below.';},9000);
      navigator.geolocation.getCurrentPosition(function(pos){clearTimeout(recovery);if(saveAndShowProductOrigin({label:'Your location',lat:pos.coords.latitude,lng:pos.coords.longitude},product))prompt.remove();},function(){clearTimeout(recovery);if(button.isConnected){button.disabled=false;button.textContent='GET IT NOW';}note.textContent='Location access was unavailable. Enter your ZIP below.';},{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
    });
    prompt.querySelector('form').addEventListener('submit',function(ev){ev.preventDefault();var q=this.querySelector('input').value.trim();var origin=origins[q];if(origin){if(laProductMode){window.location.href='/pages/stores?pickup_sandbox=91601-two-stores';return;}saveAndShowProductOrigin(origin,product);prompt.remove();}else prompt.querySelector('span').textContent=laProductMode?'Enter the supplied test ZIP 91601.':'Tester ZIPs: 83704, 83687, 83815, 80202, or 04401.';});
  }
  function initProductPageTester(){
    var handle=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1]||'';var product=products.find(function(p){return p.handle===handle;});if(!product)return;
    document.documentElement.classList.add('oej-product-pickup-tester-active');
    if(laProductMode){saveAndShowProductOrigin(origins['91601'],product);productLocationPrompt(product);return;}
    var prior=savedOrigin();if(prior)saveAndShowProductOrigin(prior,product);else productLocationPrompt(product);
    if(navigator.geolocation)navigator.geolocation.getCurrentPosition(function(pos){saveAndShowProductOrigin({label:'Your location',lat:pos.coords.latitude,lng:pos.coords.longitude},product);},function(){if(!prior)productLocationPrompt(product);},{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
  }
  var css=document.createElement('style');
  css.textContent='.oej-pickup-sandbox{background:#fff7fb;color:#42233b;margin:0 calc(50% - 50vw);padding:42px 20px 140px;font-family:inherit}.oej-pickup-sandbox>*{max-width:1180px;margin-left:auto;margin-right:auto}.oej-pick-hero{border-radius:34px;padding:44px;background:radial-gradient(circle at 85% 15%,rgba(248,125,190,.28),transparent 32%),linear-gradient(135deg,#fff,#f8dff5);box-shadow:0 20px 50px rgba(92,42,80,.12)}.oej-pick-eyebrow{text-transform:uppercase;letter-spacing:.14em;color:#c33c91;font-weight:900;font-size:12px}.oej-pick-populated-logo{width:min(100%,430px);min-height:136px;margin:22px auto 24px;padding:14px 24px;border:1px solid #efc9e2;border-radius:26px;background:rgba(255,255,255,.96);box-shadow:0 14px 34px rgba(92,42,80,.10);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;text-align:center}.oej-pick-populated-logo img{display:block;width:auto;max-width:340px;height:auto;max-height:104px;object-fit:contain}.oej-pick-populated-logo small{font-size:12px;color:#7a506d;font-weight:800}.oej-pick-populated-logo.is-fallback strong{font-family:Georgia,serif;font-size:28px;color:#35152f}.oej-pick-populated-logo.is-fallback small{font-size:11px;text-transform:uppercase;letter-spacing:.12em}.oej-pick-hero h1,.oej-pickup-sandbox h2{font-family:Georgia,serif;color:#35152f;letter-spacing:-.04em}.oej-pick-hero h1{font-size:clamp(42px,7vw,76px);margin:8px 0 14px}.oej-pick-hero p{max-width:760px;line-height:1.6;color:#69475f}.oej-pick-search{display:flex;gap:10px;max-width:560px;margin:24px 0 14px}.oej-pick-search input{flex:1;border:1px solid #efb9dc;border-radius:999px;padding:14px 18px;background:#fff}.oej-pick-search button,.oej-pick-btn,.oej-pick-sticky a,.oej-pick-product a,.oej-pick-store-grid a{border:0;border-radius:999px;background:#f26aa7;color:#fff!important;text-decoration:none!important;font-weight:900;padding:12px 18px;display:inline-flex;justify-content:center;align-items:center}.oej-pick-status{display:inline-flex;background:#fff;border:1px solid #f0c8e4;border-radius:999px;padding:10px 14px;color:#58304d}.oej-pick-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-top:24px}.oej-pick-panel,.oej-pick-product,.oej-pick-store-grid article{background:#fff;border:1px solid #f1cfe6;border-radius:26px;padding:22px;box-shadow:0 14px 34px rgba(92,42,80,.08)}.oej-pick-products,.oej-pick-stores{margin-top:42px}.oej-pick-more{display:flex!important;width:100%;margin-top:18px;background:#321c35!important;color:#fff!important;min-height:50px;text-transform:uppercase;letter-spacing:.06em;cursor:pointer}.oej-pick-product-link{display:block;color:inherit!important;text-decoration:none!important}.oej-pick-product-link .oej-pick-product{height:100%;transition:transform .18s ease,box-shadow .18s ease}.oej-pick-product-link:hover .oej-pick-product{transform:translateY(-4px);box-shadow:0 18px 40px rgba(92,42,80,.15)}.oej-pick-product b{display:block;margin-top:12px;color:#c33c91;font-size:13px}.oej-product-pickup-prompt{max-width:720px;margin:22px auto;padding:20px;border:1px solid #efc9e2;border-radius:22px;background:#fff7fb;color:#42233b;display:grid;gap:10px}.oej-product-pickup-prompt>em{font-style:normal;text-align:center;color:#8b647d;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.08em}.oej-product-pickup-get-now{width:100%;min-height:54px;border:0;border-radius:999px;background:linear-gradient(135deg,#f26aa7,#d73e91);color:#fff;font-size:17px;font-weight:950;letter-spacing:.05em;box-shadow:0 12px 28px rgba(215,62,145,.24);cursor:pointer}.oej-product-pickup-get-now:hover{filter:brightness(.97);transform:translateY(-1px)}.oej-product-pickup-get-now:disabled{opacity:.72;cursor:wait}.oej-product-pickup-prompt form{display:flex;gap:8px}.oej-product-pickup-prompt input{min-width:0;flex:1;border:1px solid #efb9dc;border-radius:999px;padding:12px 16px}.oej-product-pickup-prompt button{border:0;border-radius:999px;background:#f26aa7;color:#fff;font-weight:900;padding:12px 18px}.oej-pick-product-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}.oej-pick-product img{width:100%;height:190px;object-fit:contain;background:#fff8fc;border-radius:18px}.oej-pick-product h3{font-size:16px;min-height:48px;color:#35152f}.oej-pick-product span,.oej-pick-store-grid span{display:inline-flex;background:#fff0fa;color:#ba2c87;border-radius:999px;padding:8px 10px;font-weight:900;margin:6px 0 12px}.oej-pick-store-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}.oej-pick-store-grid article p{min-height:54px;color:#6b4b62}.oej-pick-sticky{position:fixed;left:18px;right:18px;top:18px;z-index:999999;max-width:980px;margin:auto;background:rgba(255,255,255,.96);backdrop-filter:blur(10px);border:1px solid #efc4e2;border-radius:24px;box-shadow:0 20px 60px rgba(78,28,68,.25);padding:14px;display:flex;gap:14px;align-items:center;color:#42233b}.oej-pick-sticky button{width:34px;height:34px;border-radius:50%;border:0;background:#fff0fa;color:#9d2978;font-size:22px}.oej-pick-sticky div{flex:1}.oej-pick-sticky span{display:block;color:#c33c91;font-weight:900;font-size:12px;text-transform:uppercase;letter-spacing:.1em}.oej-pick-sticky strong{display:block;color:#35152f;font-size:18px}.oej-pick-sticky small{display:block;color:#6b4b62;line-height:1.35}@media(max-width:900px){.oej-pick-grid,.oej-pick-product-grid,.oej-pick-store-grid{grid-template-columns:1fr 1fr}.oej-pick-sticky{align-items:flex-start;flex-wrap:wrap}}@media(max-width:620px){.oej-pick-hero{padding:28px}.oej-pick-grid,.oej-pick-product-grid,.oej-pick-store-grid{grid-template-columns:1fr}.oej-pick-search{flex-direction:column}.oej-pick-sticky{left:10px;right:10px;top:10px}}';
  document.head.appendChild(css);
  var meta=document.createElement('meta'); meta.name='robots'; meta.content='noindex,nofollow,noarchive'; document.head.appendChild(meta);
  document.title='Private Pickup Banner Sandbox — OEJ';
  function startPickupSandbox(){ if(productMode) initProductPageTester(); else render(laLocatorMode ? origins['91601'] : defaultOrigin); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',startPickupSandbox); else startPickupSandbox();
})();
/* OEJ_PICKUP_SANDBOX_20260709_END */
